module.exports = __webpack_public_path__ + "static/media/about-certificate-img2.95ee80fc.jpg";